import api from './api'

// Ordem dos grupos buscada ao vivo (não vem do snapshot gravado no item/procedimento/OS),
// assim mudar a ordem em Grupos de Checklist reflete em todo lugar.
export async function fetchGroupOrders() {
    try {
        const response = await api.get('/checklistGroup/orders')
        return response.data.orders || {}
    } catch {
        return {}
    }
}

// Agrupa itens por grupo; itens seguem item.order.
// Ordem dos grupos: com `groupOrders` (ao vivo, ex.: tela de Procedimento) usa ela; sem, usa o
// snapshot gravado em item.group.order (OS: congelado na criação, não muda depois).
// Grupo sem ordem conhecida (OS antiga, apagado, sem grupo) vai pro fim, em ordem alfabética.
export function buildChecklistSections(items, groupOrders = null) {
    const map = new Map()
    items.forEach((item) => {
        const groupLabel = item.group?.label || 'Sem grupo'
        if (!map.has(groupLabel)) map.set(groupLabel, { groupLabel, groupId: item.group?.value, snapshot: item.group?.order, items: [] })
        map.get(groupLabel).items.push(item)
    })
    const rank = (s) => (groupOrders ? groupOrders[s.groupId] : s.snapshot) ?? Infinity
    return Array.from(map.values())
        .map((s) => ({ ...s, items: s.items.sort((a, b) => (a.order ?? 0) - (b.order ?? 0) || a.name.localeCompare(b.name)) }))
        .sort((a, b) => {
            const ra = rank(a), rb = rank(b)
            if (ra !== rb) return ra < rb ? -1 : 1
            return a.groupLabel.localeCompare(b.groupLabel)
        })
}
